/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import Modal from "react-modal"
import { postRequest, getRequest } from "utils/request"

import { Accordion, AccordionTab } from "primereact/accordion"

import "../style.css"
import { putRequest } from "utils/request"

import Swal from "sweetalert2"

import { i18n } from "../../../translate/i18n"
import { useNotification } from "hooks/notification"
import { CircularProgress, Tooltip, makeStyles } from "@material-ui/core"
import { format as dateFnsFormat } from "date-fns"
import { deleteRequest } from "utils/request"
import format from "utils/dateFormat"
import { useAuth } from "hooks/auth"
import { BtnTakeOver } from "./BtnTakeOver"
import { RedirectTicketForm } from "./RedirectTicket"
import { ChangeTicketStatus } from "./ChangeTicketStatus.tsx"
import { ChangeTicketType } from "./ChangeTicketType"
import { ApplyShortcut } from "./ApplyShortcut"

export default function EditTicket({
  company,
  description,
  selectTicketId,
  handleUpdate,
  handleInput,
  ticketStatus,
  blockTicket,
  skuteTicket,
  customer,
  setCustomer,
  companyStatus,
  skuteChannelTicket,
  setTicketData,
  ticketData,
  handleTakeOn,
}) {
  const [selecteduser, setSelectedUser] = useState("")
  const [listuser, setListUser] = useState([])
  const [liststatus, setListStatus] = useState([])
  // const [listshortcut, setListShortcut] = useState([]);
  const [selectedstatus, setSelectedStatus] = useState("")
  const [selectedStatusRealCode, setSelectedStatusRealCode] = useState("")
  const [feedback, setFeedback] = useState(false)
  const [feedbackDb, setFeedbackDb] = useState(false)
  // const [selectedshortcut, setSelectedShortcut] = useState({});
  const [ticketHistory, setTicketHistory] = useState([])
  const [listType, setListType] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingModal, setLoadingModal] = useState(false)
  const [modal, setModal] = useState(false)
  const [ids, setIds] = useState({})
  const [update, setUpdate] = useState(0)
  const [newDescription, setNewDescription] = useState("")
  const [ticketCount, setTicketCount] = useState("")
  const [scheduleByTicket, setScheduleByTicket] = useState([])
  const [scheduleModal, setScheduleModal] = useState(false)
  const [date, setDate] = useState("")
  const [openIntegration, setOpenIntegration] = useState(null)
  const { selectedCompany, updateHeaderSelectedTicket } = useNotification()
  const { user } = useAuth()
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      minHeight: "30%",
      height: "60%",
      minWidth: "580px",
      position: "relative",
    },
    overlay: {
      overflow: "auto",
      transition: "(top 0.4s, opacity 0.4s)",
      zIndex: 1003,
      background: "rgba(0, 0, 0, 0.4)",
    },
  }

  const getOpenIntegration = async () => {
    const { data } = await getRequest(
      `companies/openintegration/${selectedCompany.id}`
    )
    if (data) {
      setOpenIntegration(data.openIntegration)
    }
  }

  useEffect(() => {
    if (selectedCompany.id > 0) {
      getOpenIntegration()
    }
    setNewDescription(description)
    setSelectedUser("")
    // setSelectedShortcut("");
    setSelectedStatus(ticketStatus)

    getScheduleByTicket()
  }, [selectTicketId])

  async function getScheduleByTicket() {
    //BUSCA AGENDAMENTOS
    if (skuteChannelTicket) {
      const ResultGet = await getRequest(
        `/events/ticket?ticketId=${selectTicketId}`
      )
      if (ResultGet.success) {
        setScheduleByTicket(ResultGet.data)
      }
    }
  }

  useEffect(async () => {
    setLoading(true)

    // Buca lista Tipos OMNI
    // Caso ticket seja concluido, listar todos os tipos.
    const onlyActive =
      Number(ticketData.CompanyStatus?.statusUser) !== 4 ? 1 : 0
    const response = await getRequest(
      `companiesticketstypes?CompanyId=${company.id}&onlyActive=${onlyActive}`
    )
    setListType(response.data)
    //Buca lista de Usuários
    await getRequest(`/tickets/staff/agentByTicket/${selectTicketId}`).then(
      function (response) {
        if (response.success) {
          setListUser(response.data)
        }
      }
    )
    //Busca feedback do ticket
    await getRequest(`/tickets/${selectTicketId}`).then(function (response) {
      if (response.success) {
        setFeedback(response.data.feedback)
        setIds(response.data)
        setFeedbackDb(response.data.feedback)
        //BUSCA QUANTIDADE DE TICKETS DO USUARIO
        getRequest(
          `/tickets/customers/company/summary?CustomerId=${response.data.CustomerId}&CompanyId=${response.data.CompanyId}&TicketId=${selectTicketId}`
        ).then((resp) => {
          if (resp.success) {
            setTicketCount(resp.data)
          }
        })
      }
    })

    //Busca lista de Status
    await getRequest(`/companiesstatus/ticket?TicketId=${selectTicketId}`).then(
      function (response) {
        setListStatus(response.data)
      }
    )

    //Buca lista shortcuts
    /* await getRequest(`companiesshortcuts?CompanyId=${selectedCompany.id}`).then(
      function (response) {
        const shortcuts = response.data;
        let opt;
        if (shortcuts.length > 0) {
          opt = `[`;
          shortcuts.forEach(function (data, index) {
            opt += `{ "value": ${data.id}, "label": "${data.title}"},`;
          });
          opt = opt.substring(0, opt.length - 1);
          opt += `]`;

          setListShortcut(JSON.parse(opt));
        } else {
          setListShortcut([]);
        }
      }
    ); */
    setLoading(false)
  }, [selectTicketId])

  const useStyles = makeStyles((theme) => ({
    customWidth: {
      fontSize: 16,
    },
  }))
  const classes = useStyles()

  const handleNewType = async () => {
    let id
    let topicId
    let customerData = customer

    listType.map((data) => {
      if (data.description === newDescription) {
        topicId = data.openId
        id = data.id
      }
    })

    if (openIntegration) {
      //Caso usuário não tenha email, solicitar geração
      if (!customer.email) {
        await Swal.fire({
          title: i18n.t("confirmEmailGeneration"),
          text: i18n.t("emailGenerationText"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: i18n.t("confirm"),
          cancelButtonText: i18n.t("cancel"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            await putRequest(`/customers/${customer.id}/generateEmail`)
              .then(function (response) {
                setCustomer(response.data)
                customerData = response.data
              })
              .catch((response) => {
                console.log(response.message)
              })
          } else {
            return
          }
        })
      }

      // Após usuário possir email, perguntar criação ticket open.
      await Swal.fire({
        title: i18n.t("currectData"),
        text: `Deseja confirmar a operação? Um ticket será criado no Open. Essa operação não pode ser desfeita`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, quero confirmar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await putRequest(`/tickets/type/${selectTicketId}`, {
            CompanyTicketTypeId: id,
            openIntegration,
            customer: customerData,
            ticketData,
            topicId,
          })
            .then((response) => {
              setTicketData(response.data.ticket)
            })
            .catch((response) => {
              console.log(response.message)
            })
        }
      })
    } else {
      await putRequest(`/tickets/type/${selectTicketId}`, {
        CompanyTicketTypeId: id,
        customer: customerData,
        ticketData,
      }).then((response) => {
        setTicketData(response.data.ticket)
      })
    }
  }

  const ChangeStatus = () => {
    setLoading(true)
    putRequest(
      `/tickets/status?id=${selectTicketId}&CompanyStatusId=${selectedstatus}`
    ).then(function () {
      handleUpdate()
    })
  }

  //ABRE O MODAL DE HISTORICO DE TICKETS
  const toggleModal = async (onlyOpen) => {
    setLoadingModal(true)
    setModal(true)
    //CARREGA O HISTORICO DE TICKETS DO USUARIO
    await getRequest(
      `/tickets/customers/company?CustomerId=${ids.CustomerId}&CompanyId=${ids.CompanyId}&onlyOpen=${onlyOpen}`
    ).then((resp) => {
      if (resp.success) {
        let tickets = []
        let value = 0
        resp.data.forEach((e) => {
          if (e.CompanyStatus.statusUser !== value || value === 0) {
            value = e.CompanyStatus.statusUser
            tickets.push([e])
          } else {
            const data = tickets.findIndex(
              (f) =>
                f[0].CompanyStatus.statusUser === e.CompanyStatus.statusUser
            )
            tickets[data].push(e)
          }
        })
        setTicketHistory(tickets)
      }
    })
    setLoadingModal(false)
  }

  /* const ChangeShortcuts = () => {
    if (selectedshortcut) {
      //Busca mensagem
      getRequest(
        `companiesshortcuts/message?id=${selectedshortcut.value}&TicketId=${selectTicketId}`
      ).then(function (response) {
        handleInput(response.data);
        setLoading(false);
      });
    }
  }; */

  const ticketRedirect = (e) => {
    setModal(false)
    if (selectTicketId !== e.id) {
      updateHeaderSelectedTicket(e.id, e.ticket)
    }
  }

  const changeFeedback = () => {
    putRequest(`/tickets/feedback/${selectTicketId}`, {
      feedback: feedback,
    })
  }

  useEffect(() => {
    if (feedbackDb !== feedback) {
      changeFeedback()
      setFeedbackDb(0)
    }
  }, [update])

  const handleNewUser = () => {
    if (selecteduser !== "") {
      setLoading(true)
      putRequest(`/tickets/set/${selectTicketId}`, {
        UserId: selecteduser,
      }).then(function () {
        handleUpdate()
      })
    }
  }

  const handleSchedule = async () => {
    if (date !== "") {
      // SALVA NOVO AGENDAMENTO
      await postRequest(`/events/agent`, {
        TicketId: selectTicketId,
        eventDate: date,
      })
      getScheduleByTicket()
      setLoading(false)
    }
  }

  const handleDelete = (id) => {
    Swal.fire({
      title: i18n.t("attemption"),
      text: i18n.t("deleteScheduling"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t("confirmEraseCompany"),
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRequest(`/events/agent/${id}`).then(function (response) {
          if (response.success) {
            getScheduleByTicket()
          }
        })
      }
    })
  }

  return (
    <>
      {!loading ? (
        <>
          <Modal
            isOpen={scheduleModal}
            style={customStyles}
            onRequestClose={() => setScheduleModal(false)}
            ariaHideApp={false}
          >
            <span
              onClick={() => setScheduleModal(false)}
              style={{
                fontSize: 30,
                position: "absolute",
                right: 15,
                top: 0,
                color: "black",
                cursor: "pointer",
              }}
            >
              <i className="fas fa-times"></i>
            </span>
            <div style={{ fontSize: "1.2vw", fontWeight: 700 }}>
              {i18n.t("scheduling") + "s"}
            </div>
            <table className="scheduling-table">
              <thead>
                <tr>
                  <th>{i18n.t("event")}</th>
                  <th>{i18n.t("date")}</th>
                  <th>{i18n.t("action")}</th>
                </tr>
              </thead>
              <tbody>
                {scheduleByTicket.map((e) => (
                  <tr key={e.id}>
                    <td>{e.event} </td>
                    <td> {dateFnsFormat(new Date(e.date), "dd/MM/yyyy")}</td>
                    <td>
                      <div
                        className="action-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(e.id)}
                      >
                        <i
                          className="mdi mdi-delete"
                          style={{ fontSize: 20 }}
                        ></i>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Modal>
          <Modal
            isOpen={modal}
            style={customStyles}
            onRequestClose={() => setModal(false)}
            ariaHideApp={false}
          >
            <span
              onClick={() => setModal(false)}
              style={{
                fontSize: 30,
                position: "absolute",
                right: 15,
                top: 0,
                color: "black",
                cursor: "pointer",
              }}
            >
              <i className="fas fa-times"></i>
            </span>
            {!loadingModal ? (
              <>
                {modal && (
                  <div style={{ display: "flex" }}>
                    <h3>{ticketHistory[0][0]?.Company?.nickName}</h3>
                    <h3 style={{ marginLeft: 100 }}>
                      {ticketHistory[0][0]?.Customer?.name}
                    </h3>
                  </div>
                )}
                <div className="content-container">
                  <Accordion activeIndex={0}>
                    {ticketHistory.map((e, index) => (
                      <AccordionTab
                        key={index}
                        header={
                          ticketHistory[index][0]?.CompanyStatus
                            ?.statusUserDescription
                        }
                      >
                        {e.map((data, index) => (
                          <div key={index} className="tickets-container">
                            <div className="tickets-info">
                              <h4 className="h4-ticket">Ticket: </h4>
                              <span
                                onClick={() => ticketRedirect(data)}
                                className="ticket-info-span-number"
                              >
                                {data.ticket}
                              </span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <div className="tickets-info">
                                  <h4 className="h4-ticket">
                                    {i18n.t("type")}:{" "}
                                  </h4>
                                  <span className="ticket-info-span">
                                    {data.CompanyTicketType?.description ||
                                      "não definido"}
                                  </span>
                                </div>
                                <div className="tickets-info">
                                  <h4 className="h4-ticket">
                                    {i18n.t("department")}:{" "}
                                  </h4>
                                  <span className="ticket-info-span">
                                    {data.CompanyDepartment.description}
                                  </span>
                                </div>
                                <div className="tickets-info">
                                  <h4 className="h4-ticket">
                                    {i18n.t("createdAt")}:{" "}
                                  </h4>
                                  <span className="ticket-info-span">
                                    {data.createdAt &&
                                      format(
                                        data.createdAt,
                                        "dd/MM/yyyy HH:mm"
                                      )}
                                  </span>
                                </div>
                              </div>
                              <div style={{ marginRight: 40 }}>
                                <div className="tickets-info">
                                  <h4 className="h4-ticket">
                                    {i18n.t("status")}:
                                  </h4>
                                  <span className="ticket-info-span">
                                    {data.CompanyStatus.internalDescription}
                                  </span>
                                </div>
                                <div className="tickets-info">
                                  <h4
                                    className="h4-ticket"
                                    style={{ textAlign: "left" }}
                                  >
                                    {i18n.t("updatedAt")}:{" "}
                                  </h4>
                                  <span className="ticket-info-span">
                                    {data.createdAt &&
                                      format(
                                        data.updatedAt,
                                        "dd/MM/yyyy HH:mm"
                                      )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </AccordionTab>
                    ))}
                  </Accordion>
                </div>
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "25vh",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </Modal>
          <div
            className="mt-2"
            style={{ position: "relative", marginTop: "2px !important" }}
          >
            <div className="container-data-tickets-area">
              {skuteTicket && (
                <p className="label-client-details-chat">
                  <label className="text-title-details-client">
                    {i18n.t("company")}:
                  </label>
                  <strong className="text-dados-details-client">
                    {company.name}
                  </strong>
                </p>
              )}
              <Tooltip
                arrow
                classes={{ tooltip: classes.customWidth }}
                title={i18n.t("totalTickets")}
              >
                <div
                  style={{ right: scheduleByTicket?.length > 0 && 50 }}
                  className="tickets-count"
                  onClick={() => toggleModal(0)}
                >
                  <span className="tickets-count-font">
                    {ticketCount.ticketCount}
                  </span>
                </div>
              </Tooltip>

              {skuteChannelTicket && scheduleByTicket?.length > 0 && (
                <Tooltip
                  arrow
                  classes={{ tooltip: classes.customWidth }}
                  title={i18n.t("scheduling")}
                >
                  <div
                    style={{ borderColor: "#f18826" }}
                    className="tickets-count"
                    onClick={() => setScheduleModal(true)}
                  >
                    <span className="tickets-count-font">
                      {scheduleByTicket.length}
                    </span>
                  </div>
                </Tooltip>
              )}

              <p className="label-client-details-chat">
                <label className="text-title-details-client">Ticket:</label>
                <strong className="text-dados-details-client">
                  {company.ticket}
                </strong>
              </p>
            </div>
          </div>
          {ticketCount.ticketOpenCount > 0 && (
            <div className="ticket-history">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <i
                  className="fas fa-exclamation-triangle"
                  style={{ marginRight: 10 }}
                />
                <div
                  onClick={() => toggleModal("1")}
                  className="text-ticket-history"
                >
                  {i18n.t("ticketOcorrency")}
                </div>
              </div>
            </div>
          )}
          <ChangeTicketType
            blockTicket={blockTicket}
            skuteTicket={skuteTicket}
            skuteChannelTicket={skuteChannelTicket}
            ticketData={ticketData}
            handleChange={(evt) => setNewDescription(evt.target.value)}
            handleSave={handleNewType}
            listType={listType}
            ticketType={ticketData?.CompanyTicketType?.description}
            newTicketType={newDescription}
          />

          <RedirectTicketForm
            blockTicket={blockTicket}
            companyStatus={companyStatus}
            listUser={listuser}
            ticket={ticketData}
            selecteduser={selecteduser}
            user={user}
            confirmAction={handleNewUser}
            handleOptionChange={(value) => setSelectedUser(value)}
          />
          <ChangeTicketStatus
            blockTicket={blockTicket}
            handleChange={(evt) => {
              const chosenStatus = liststatus.find(
                (status) => String(status.id) === String(evt.target.value)
              )
              if (chosenStatus) {
                setSelectedStatusRealCode(chosenStatus.statusUser)
              }
              setSelectedStatus(evt.target.value)
            }}
            handleSave={ChangeStatus}
            liststatus={liststatus}
            selectedStatusRealCode={selectedStatusRealCode}
            selectedstatus={selectedstatus}
            ticketType={ticketData?.CompanyTicketType?.description}
            tooltipWidth={classes.customWidth}
          />
          <ApplyShortcut
            blockTicket={blockTicket}
            disableLoading={() => {
              setLoading(false)
            }}
            handleInput={handleInput}
            selectTicketId={selectTicketId}
            selectedCompany={selectedCompany}
          />

          {skuteChannelTicket && (
            <>
              <label className="title-combo-details-client-chat">
                {i18n.t("scheduling")}
              </label>
              <div className="form-row">
                <div className="form-group col-lg-8">
                  <input
                    type="date"
                    className="form-control"
                    id="example-select6"
                    disabled={blockTicket}
                    value={date}
                    onChange={(value) => setDate(value.target.value)}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-outline-success"
                  style={{ height: 38 }}
                  onClick={handleSchedule}
                  disabled={blockTicket}
                >
                  <i className=" uil-exchange"></i> {i18n.t("confirm")}
                </button>
              </div>
            </>
          )}
          {skuteTicket &&
            Number(process.env.REACT_APP_SKUTE_ID) !== company.id && (
              <>
                <div className="checkbox-container">
                  <input
                    name="feedback"
                    checked={feedback}
                    onChange={() => {
                      setFeedback(!feedback)
                      setUpdate(update + 1)
                    }}
                    type="checkbox"
                    className="checkbox"
                  />
                  <div style={{ marginLeft: 15 }}>
                    {i18n.t("companyReturnContact")}
                  </div>
                </div>
              </>
            )}

          <BtnTakeOver
            onClickHandler={handleTakeOn}
            user={user}
            ticket={ticketData}
          />
        </>
      ) : (
        <div className="area-loading-details-profile">
          <CircularProgress />
        </div>
      )}
    </>
  )
}
